import { createContext } from 'react';
import {
	TFileId,
	IItemForGetShortInfo,
	TLanguageIDs,
	IMenuTranslation,
	IDefaultLanguage,
	TCategoryType,
	ICreateCategoryV2,
} from 'types';

export type TTCategoryType = Nullable<TCategoryType>;
export type TTypeOfModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error'
	| 'defaultTranslationIsEmpty';

export interface ICreateCategoryState {
	fileId: TFileId;
	fetchedCustomers: IItemForGetShortInfo[];
	IDSelectedCustomer: Nullable<string>;
	fetchedRestaurants: IItemForGetShortInfo[];
	IDsSelectedRestaurant: string[];
	nameOfCategory: string;
	categoryType: TTCategoryType;
	isRestricted: boolean;
	hasSchedulePriority: boolean;
	activationSchedule: string;
	deactivationSchedule: string;
	defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	selectedTranslationTab: Nullable<TLanguageIDs>;
	translations: IMenuTranslation[];
	dataForSubmit: Nullable<ICreateCategoryV2>;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const createCategoryInitialState: ICreateCategoryState = {
	fileId: null,
	fetchedCustomers: [],
	IDSelectedCustomer: null,
	fetchedRestaurants: [],
	IDsSelectedRestaurant: [],
	nameOfCategory: '',
	categoryType: null,
	isRestricted: false,
	hasSchedulePriority: false,
	activationSchedule: '',
	deactivationSchedule: '',
	defaultCustomerLanguage: null,
	selectedTranslationTab: null,
	translations: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface ICreateCategoryContext extends ICreateCategoryState {
	setFileId(value: TFileId): void;
	setFetchedCustomers(value: IItemForGetShortInfo[]): void;
	setIDCustomer(value: Nullable<string>): void;
	setFetchedRestaurants(value: IItemForGetShortInfo[]): void;
	setIDsRestaurant(value: string[]): void;
	changeNameOfCategory(value: string): void;
	setCategoryType(value: TTCategoryType): void;
	toggleIsRestricted(): void;
	toggleHasSchedulePriority(): void;
	changeActivationSchedule(value: string): void;
	changeDeactivationSchedule(value: string): void;
	setFetchedTranslations(value: TLanguageIDs[], defaultCustomerLanguage: Nullable<IDefaultLanguage>): void;
	setTranslationTab(value: Nullable<TLanguageIDs>): void;
	changeNameTranslation(languageId: TLanguageIDs, value: string): void;
	setDataForSubmit(data: ICreateCategoryV2): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	resetFields(): void;
}

export const CreateCategoryContext = createContext<ICreateCategoryContext>({
	setFileId: () => undefined,
	setFetchedCustomers: () => undefined,
	setIDCustomer: () => undefined,
	setFetchedRestaurants: () => undefined,
	setIDsRestaurant: () => undefined,
	changeNameOfCategory: () => undefined,
	setCategoryType: () => undefined,
	toggleIsRestricted: () => undefined,
	toggleHasSchedulePriority: () => undefined,
	changeActivationSchedule: () => undefined,
	changeDeactivationSchedule: () => undefined,
	setFetchedTranslations: () => undefined,
	setTranslationTab: () => undefined,
	changeNameTranslation: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...createCategoryInitialState,
});
